import { Info } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeIn } from "../../lib/motion";
import { TRIAL } from "../../constants/testIds";

// UX-TRIAL §1/"HELD SIGNUP → SHARED DEMO GYM, NEVER A DEAD END": while a held trial_request
// awaits Kairoo operator review, the prospect's session (`is_trial_preview`, set on `session` by
// `trial_engine.mint_demo_preview_session`) is a real read-mostly login into the shared UX-DEMO
// sales-demo org — `/me` surfaces the flag, this banner is the only UI difference from a real
// tenant's own dashboard (every write already 403s via the existing `trial_preview` role's
// view-only permission set, no special-cased bypass here).
export function DemoPreviewBanner() {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div
      data-testid={TRIAL.demoPreviewBanner}
      {...fadeIn(reducedMotion)}
      className="mx-8 mt-4 rounded-[10px] px-4 py-3 flex items-center gap-2 text-sm font-medium"
      style={{ background: "var(--status-trial-bg)", color: "var(--status-trial-text)" }}
    >
      <Info size={16} />
      You're previewing our demo gym with live sample data — your trial request is under review and will activate soon.
    </motion.div>
  );
}
